export default __webpack_public_path__ + "static/PCBenefits-3470704c3ae5b6289d37acb618ae3b16.png";